
export const Empresas = {
    Simpress: "27d8028f-692c-4c93-be78-d5aaf44868fe",
    Embrart: "ccf98406-0cfd-40ed-94d4-cc1ff3469f4a",
    BRT: "84c962de-26c5-43f4-aeae-22b4e4022a43",
    Petrobahia: "95e6b155-8152-4c3c-8430-bef3333be2aa",
    POC: "83189633-c330-498f-8414-36e99283b998",
    Brf: "f5ad420e-2153-41d5-b2e8-9224d3f50b72",
    Triunfante: "0bc14ff3-6013-4eff-bb0f-63a6eef66836",
    JnsSeguradora: "bd91076a-8c96-4214-b099-de785a690f5e",
    Trombini: "581dacfe-89b1-4810-ba48-385bd589d84f",
    Rdp: "61269453-bb0e-4a29-960c-583a0b273925",
    POC2: "2e9d20bd-4f73-4302-b55a-d4ccb8004653"
    // Adicione mais empresas conforme necessário
};